export default __webpack_public_path__ + "static/media/apostilao-linguagens-humanas.51234b6a.jpg";